import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Link from "@material-ui/core/Link";
import Toolbar from "@material-ui/core/Toolbar";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    boxShadow: "none",
    paddingLeft: 48,
    paddingRight: 48,
  },
  logo__container: {
    minHeight: 82,
  },
  logo: {
    width: "152px",
    height: "42px",
  },
}));

function Header() {
  const classes = useStyles();
  return (
    <AppBar className={classes.header} position="relative">
      <Toolbar className={classes.logo__container}>
        <Icon className={classes.logo}>
          <Link href="https://vidyard.com" target="_blank">
            <img
              src="https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/images/vidyard-logo.svg"
              alt="Vidyard Logo"
            />
          </Link>
        </Icon>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
